export default {
  'emailMessageTrace.title': 'Gestionar Trazas Correo',
  'emailMessageTrace.id': 'ID',
  'emailMessageTrace.hideFilter': 'Ocultar Filtros',
  'emailMessageTrace.showFilter': 'Filtro Avanzado',
  'emailMessageTrace.startDate': 'Fecha de Inicio',
  'emailMessageTrace.endDate': 'Fecha de Fin',
  'emailMessageTrace.select.type': 'Seleccione Tipo',
  'emailMessageTrace.event': 'Evento',
  'emailMessageTrace.events': 'Eventos',
  'emailMessageTrace.processInstance': 'Solicitud',
  'emailMessageTrace.to': 'Para',
  'emailMessageTrace.responseCode': 'Código Respuesta',
  'emailMessageTrace.customArgs': 'Argumentos Personalizados',
  'emailMessageTrace.from': 'De',
  'emailMessageTrace.select.event': 'Seleccione Evento',
  'emailMessageTrace.select.user': 'Seleccione Usuario',
};
